import { render, staticRenderFns } from "./SrProjectForm.vue?vue&type=template&id=4a643cb1&"
import script from "./SrProjectForm.vue?vue&type=script&lang=js&"
export * from "./SrProjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports